import * as React from "react";
import { forwardRef } from "react";
const SvgHeadingText = (props, ref) => <svg width={24} height={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}><path d="M15.4987 11.0192V12.5288H8.45666V11.0192H15.4987ZM8.72475 6V18H7V6H8.72475ZM17 6V18H15.2842V6H17Z" /></svg>;
const ForwardRef = forwardRef(SvgHeadingText);
export default ForwardRef;